<div *ngIf='details?.length'>
  <div *ngFor='let detail of details'>
    <!-- ACTIONS -->
    <div *ngIf='detail?.body?.actions?.length' class='dviewer-actions'>
      <div class="dviewer-actions_left">
        <div *ngIf='detail?.body?.actions?.length > 0' class='btn-group'>
          <button (click)='onClickAction(detail.body.actions[0])'
                  *ngIf='detail?.body?.actions[0].visible'
                  [disabled]='detail.body.actions[0].disabled'
                  [ngClass]="{'disabled-first': detail.body.actions[0].disabled}"
                  class='btn btn-sm btn-primary btn-action m-0'
                  ngbautofocus="false" type='button'>
            {{ detail.body.actions[0]?.label | async }}
          </button>

          <div *ngIf='detail.body.actions.length > 1' class='btn-group' ngbDropdown
               role='group'>
            <button *ngIf='detail?.body?.actions[0].visible'
                    class='btn btn-sm btn-primary dropdown-toggle-split'
                    ngbDropdownToggle>
            </button>
            <div class='dropdown-menu' ngbDropdownMenu>
              <ng-container *ngFor='let action of detail.body.actions'>
                <ng-container *ngIf='action.visible'>
                  <hr *ngIf='action.separateFromAbove' class='my-2'>
                  <button
                    (click)='onClickAction(action)'
                    [disabled]='action.disabled' class='btn-sm'
                    ngbDropdownItem
                    type='button'>
                    <pt-icon
                      *ngIf='action.detailIcon'
                      [iconType]='action.detailIcon.type'
                      [key]='action.detailIcon.key'
                      [size]='action.detailIcon.size'>
                    </pt-icon>
                    {{ action.label | async }}
                  </button>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>

        <ng-container *ptIfDeleteAction="detail.body.actions, action as a">
          <button (click)='onClickAction(a)' [disabled]='a?.disabled'
                  class='btn btn-sm btn-outline-danger btn-action' type='button'>
            {{ a?.label | async }}
          </button>
        </ng-container>
      </div>
      <div class="dviewer-actions_right"></div>
    </div>

    <!-- ATTRIBUTE -->
    <div class='dviewer-attribute-container'>
      <ng-container *ngFor='let attribute of detail.body.attributes'>
        <ng-container *ngxPermissionsOnly='attribute.permissVisible'>
          <ng-container *ngIf='attribute.showInAll'>
            <pt-details-attribute
              [attribute]='attribute'
            ></pt-details-attribute>
          </ng-container>
        </ng-container>
      </ng-container>

      <div #collapse='ngbCollapse' [(ngbCollapse)]='isCollapsedOtherAttributes'>
        <ng-container *ngFor='let attribute of detail.body.attributes'>
          <ng-container *ngxPermissionsOnly='attribute.permissVisible'>
            <ng-container *ngIf='!attribute.showInAll'>
              <pt-details-attribute
                [attribute]='attribute'
              ></pt-details-attribute>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>

      <div *ngIf="!enableExpand" class="space-no-more"></div>

      <button (click)='collapse.toggle()'
              *ngIf='enableExpand'
              [attr.aria-expanded]='!isCollapsedOtherAttributes'
              aria-controls='collapseExample'
              class='btn btn-sm btn-more'
              type='button'>
        <div [ngClass]="{ 'flip-icon': !isCollapsedOtherAttributes}"
             ngbTooltip="{{(isCollapsedOtherAttributes ? 'LABELS.EXPAND' : 'LABELS.REDUCE') | translate}}">
          <pt-icon [iconType]='iconType'
                   [key]='iconArrow'
                   [size]='iconSize'>
          </pt-icon>
        </div>
      </button>

    </div>
  </div>
</div>
